<template>
  <figure>
    <div class="md:flex rounded-xl p-8 md:p-0">
      <img
        class="w-28 h-28 object-cover md:rounded-md md:w-48 md:h-full rounded-full mx-auto"
        src="@/assets/photo.png"
        alt=""
        width="1000"
        height="1411" />
      <div class="pt-6 md:p-8 text-center md:text-left space-y-4">
        <div>
          <div class="text-indigo-600 dark:text-indigo-400">
            <div class="text-2xl">Dr. Yuxuan PANG (龐 宇軒)</div>
            <br />
            <div class="text-lg">Ph.D.</div>
          </div>
          <div class="font-medium text-light-primary dark:text-dark-primary">
            School of Science and Engineering,<br />
            The Chinese University of Hong Kong, Shenzhen,<br />
            Shenzhen, Guandong, PR China.
          </div>
        </div>
      </div>
    </div>
    <div class="flex flex-wrap justify-center w-full my-4">
      <button class="btn btn-indigo w-44" onclick="window.open('https://scholar.google.com/citations?user=1icGf4EAAAAJ')">
        <font-awesome-icon icon="fa-solid fa-book" /> Google Scholar
      </button>
      <button class="btn btn-grey w-44" onclick="window.open('https://github.com/poncey')">
        <font-awesome-icon icon="fa-brands fa-github-alt" /> Github
      </button>
      <button class="btn btn-green w-44" onclick="location.href='mailto:poncey314@icloud.com';">
        <font-awesome-icon icon="fa-solid fa-envelope" /> Email
      </button>
      <button class="btn btn-blue w-44" onclick="window.open('https://www.linkedin.com/in/yuxuan-pang-13237812b/')">
        <font-awesome-icon icon="fa-brands fa-linkedin" /> Linkedin
      </button>
    </div>
    <div>
      <div class="relative text-2xl text-light-primary dark:text-dark-primary">
        <h1 class="">About me</h1>
        <div class="absolute bottom-0 left-0 w-full h-0.5 bg-gray-400"></div>
      </div>
      <p class="text-justify font-medium text-light-primary dark:text-dark-primary my-4">
        I received my Ph.D. degree of Computer and Information Engineering in the School of Science and Engineering,
        <a href="https://www.cuhk.edu.cn/en" target="_blank" class="text-blue-400 visited:text-purple-400">
          The Chinese University of Hong Kong, Shenzhen (CUHK-Shenzhen)</a
        >, supervised by Prof. Tzong-Yi LEE and Prof. Hsien-Da HUANG. I received my B.Eng. in Electronic and Information Engineering from School of
        Computer Science and Engineering in the
        <a href="http://english.neu.edu.cn/" target="_blank" class="text-blue-400 visited:text-purple-400">Northeastern University</a> of China in
        2019. <br /><br />
        My research interest focus on AI for life science, especially includes machine learning, deep learning and their applications associated with
        bioinformatics.
        <br /><br />
        If you want to talk with me about any fascinating issues or queries about bioinformatics and data analysis related to healthcare, please
        contact me via email!
        <br /><br />
      </p>
    </div>

    <div>
      <div class="relative text-2xl text-light-primary dark:text-dark-primary">
        <h1 class="">News</h1>
        <div class="absolute bottom-0 left-0 w-full h-0.5 bg-gray-400"></div>
      </div>
      <ul class="list-disc list-outside text-light-primary dark:text-dark-primary my-4 pl-4">
        <li class="my-2">
          <span class="font-semibold"
            >I will soon be joining the The Institute of Medical Science, The University of Tokyo (IMSUT) as a postdoctoral researcher in Nov.
            2023.</span
          >
        </li>
        <li class="my-2">
          <span>I have won the 2022-2023 PhD Graduate Award, bestowed by Ganghong Corporation and the School of Medicine, CUHK-Shenzhen.</span>
        </li>
        <li class="my-2">I have successfully defended my doctoral dissertation and received my doctoral degree on July 31, 2023!</li>
      </ul>
    </div>
  </figure>
</template>

<script>
export default {
  name: "Home",
};
</script>

<style>
.btn-blue {
  @apply bg-blue-600 text-white dark:bg-blue-400 dark:text-gray-800;
}
.btn-grey {
  @apply bg-gray-600 dark:bg-gray-400 text-white dark:text-gray-800;
}
.btn-green {
  @apply bg-green-600 dark:bg-green-400 text-white dark:text-gray-800;
}
.btn-indigo {
  @apply bg-indigo-600 dark:bg-indigo-400 text-white dark:text-gray-800;
}
</style>
